export function openPaymentWidget(confirmationToken, onSuccess) {
  if (!window.YooMoneyCheckoutWidget) {
    console.error("YooKassa widget not loaded");
    return;
  }

  const checkout = new window.YooMoneyCheckoutWidget({
    confirmation_token: confirmationToken,
    error_callback: (err) => console.error(err),
    customization: { modal: true }, // <- ключ к модалке
  });

  // по желанию: обработчики и зачистка
  checkout.on?.('complete', () => {
    checkout.destroy();
    onSuccess?.();
  });
  checkout.on?.('fail', (err) => {
    console.error(err);
    checkout.destroy();
  });

  // можно строкой-селектором, можно DOM-узлом
  checkout.render('body', { autoOpen: true });
}
